<template>
    <div style="margin-top: -10px; ">
        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>{{buildingName}} / Commitee</span>
                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
                <router-link class="btn btn-table" :to="{
          name: 'property',
          params: { buildingId: buildingId, buildingName: buildingName },
        }"><i class="fas fa-plus"></i></router-link>-->
                    <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>

                    <span @click="showSearch()"
                          style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                        <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                    <userMenu />
                </div>
            </div>
        </div>

        <div class="row">

            <div class="offset-md-9 col-3 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <span style="margin-right:5px">Add New Member</span>
                    <router-link class="btn btn-table" :to="{name:'committee', params:{buildingId:buildingId, buildingName:buildingName}}"><i class="fas fa-plus"></i></router-link>
                </div>
            </div>
        </div>

        <div v-if="false" class="row">
            <div class="pull-left col-lg-3 col-md-3 col-sm-5 col-12" style="padding-left:0;margin-bottom:10px;display:inline-flex">
                <div class="size" style="margin-left:15px">
                    Show
                    <select class="size-select" v-model="size">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                    </select>
                    Entries
                </div>
            </div>
            <div class="sortBy col-lg-3 col-md-3 col-sm-5 col-12" style="margin-bottom:22px">
                Sort By
                <select class="sortBy-select" v-model="sortBy">
                    <option value="Name">Name</option>
                    <option value="Position">Position</option>
                </select>
            </div>
            <div class="search col-lg-3 col-md-3 col-sm-4 col-6 marginLeftSmallScreen" style="min-width:180px; margin-top:12px">
                <span class="fa fa-search"></span>
                <input type="text" class="form-control" name="searchText" id="searchText" placeholder="Search Committee..." v-model="filter">
            </div>
            <div class="col-lg-3 col-md-3 col-sm-4 col-6 pull-right" style="text-align:right">
                <router-link class="btn btn-primary" :to="{name:'committee', params:{buildingId:buildingId, buildingName:buildingName}}">Add Member</router-link>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th scope="col" style="width:19%">No</th>
                        <th scope="col" style="width:19%">Name</th>
                        <th scope="col" style="width:19%">Phone number</th>
                        <th scope="col" style="width:19%">Position</th>
                        <th scope="col" style="width:19%">Email</th>
                        <th scope="col" style="width:5%"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="committee, key in paginatedData" class="clickable-row">
                        <td scope="row" class="clickable-column"><a @click.prevent="editItem(committee)">{{ ++key }}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(committee)">{{ committee.name}} {{ committee.surname }}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(committee)">{{ committee.phoneNumber}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(committee)">{{ committee.positionString}}</a></td>
                        <td class="clickable-column"><a @click.prevent="editItem(committee)">{{ committee.email}}</a></td>
                        <td>
                            <a class="btn btn-table" @click.prevent="deleteItem(committee)"><i class="fas fa-times"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- MODAL IS HERE -->
        <modal :scrollable="true" name="deleteAlert" @before-open="beforeOpen" height="auto" :minHeight="150" width="400">
            <div class="" role="document">
                <div class="">
                    <!-- Modal content-->
                    <deleteAlert v-on:close="modalClosed" :entity-id="selectedItemId" request="committees" entity="committee member" />
                </div>
            </div>
        </modal>
        <div class="row">
            <div class="col-8 table-summary">
                <span>  Showing {{startEntry}} to {{endEntry}} of {{numberOfEntries}} entries </span>
            </div>
            <div class="col-4">
                <paginate :page-count="numberOfPages"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="clickCallback"
                          :prev-text="'<'"
                          :next-text="'>'"
                          :container-class="'pagination'"
                          :page-class="'page-item'">
                </paginate>
            </div>
        </div>
    </div>
</template>
<style scoped>
@media (max-width: 959px) {
  .marginLeftSmallScreen {
    margin-left: 13px !important;
    margin-right: -13px !important;
  }
}
</style>
<script>
import { mapState } from "vuex";
export default {
  data: function () {
    return {
      size: 10,
      sortBy: "Name",
      filter: "",
      pageNumber: 0,
      committees: [],
      buildingId: 0,
   //   buildingName: "",
      selectedItemId: 0,
      visibleSearch: false,
    };
  },
  mounted() {
    this.buildingId = this.$route.params.buildingId;
   // this.buildingName = this.$route.params.buildingName;
    //this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    getCommittees() {
      var committees = this.committees.filter((supplier) => {
        return supplier.name.toLowerCase().includes(this.filter.toLowerCase());
      });

      return committees;
    },
    numberOfEntries() {
      return this.getCommittees.length;
    },
    numberOfPages() {
      let l = this.numberOfEntries,
        s = this.size;
      return Math.ceil(l / s);
    },
    startEntry() {
      if (this.numberOfEntries == 0) {
        return 0;
      }
      if (this.pageNumber + 1 == 1) {
        return 1;
      } else {
        return this.pageNumber * this.size + 1;
      }
    },
    endEntry() {
      if (this.numberOfEntries <= this.size) {
        return this.numberOfEntries;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 == 1) {
        return this.size;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 > 1) {
        if (this.numberOfEntries - this.size * (this.pageNumber + 1) > 0) {
          return this.size * (this.pageNumber + 1);
        } else {
          return this.numberOfEntries;
        }
      } else {
        return NaN;
      }
    },
    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      var sorted = [...this.getCommittees];

      if (this.sortBy == "Name") {
        sorted.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase()
            ? 1
            : b.name.toLowerCase() > a.name.toLowerCase()
            ? -1
            : 0
        );
      } else {
        sorted.sort((a, b) =>
          a.positionString.toLowerCase() > b.positionString.toLowerCase()
            ? 1
            : b.positionString.toLowerCase() > a.positionString.toLowerCase()
            ? -1
            : 0
        );
      }
      return sorted.slice(start, end);
    },
  },
  methods: {
    showSearch() {
      this.visibleSearch = !this.visibleSearch;
    },
    clickCallback(pageNum) {
      this.pageNumber = pageNum - 1;
    },
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/committees/building?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.committees = data;
        });
    },
    editItem: function (item) {
      this.$router.push({
        name: "committee",
        params: {
          id: item.id,
          buildingId: this.buildingId,
          buildingName: this.buildingName,
        },
      });
    },
    modalClosed: function (itemDeleted) {
      if (itemDeleted) this.fetchStatement();
    },
    deleteItem: function destroy(item) {
      this.selectedItemId = item.id;
      this.deleteAlert();
    },
    deleteAlert: function () {
      this.$modal.show("deleteAlert");
    },
  },
};
</script>